import { NgModule } from '@angular/core';
import { GuardService } from './core/auth/guard.service';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';


const routes: Routes = [
  {
    path: '',
    canActivate: [GuardService],
    redirectTo: '/app/home',
    //redirectTo: 'register/confirmation',
    pathMatch: 'full'
  },
  { path: 'app', loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule) },
  // {
  //   path: 'home',
  //   canActivate: [GuardService],
  //   loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)
  // },
  {
    path: 'list',
    loadChildren: () => import('./list/list.module').then(m => m.ListPageModule)
  },
  // {
  //   path: 'incidents',
  //   loadChildren: () => import('./incidents/incidents.module').then(m => m.IncidentsPageModule)
  // },
  // {
  //   path: 'vehicles',
  //   loadChildren: () => import('./vehicles/vehicles.module').then(m => m.VehiclesPageModule)
  // },
  // {
  //   path: 'account',
  //   loadChildren: () => import('./account/account.module').then(m => m.AccountPageModule)
  // },

  { path: 'auth/login', loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule) },
  { path: 'auth/signup', loadChildren: () => import('./signup/signup.module').then(m => m.SignupPageModule) },   
  { path: 'auth/forgot-password', loadChildren: () => import('./login/forgot-password/forgot-password.module').then( m => m.ForgotPasswordPageModule)},
  {
    path: 'register',
    loadChildren: () => import('./signup/register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'incidents',
    loadChildren: () => import('./incidents/incidents.module').then( m => m.IncidentsPageModule)
  },
  {
    path: 'vehicles',
    loadChildren: () => import('./vehicles/vehicles.module').then( m => m.VehiclesPageModule)
  },
  {
    path: 'account',
    loadChildren: () => import('./account/account.module').then( m => m.AccountPageModule)
  },
  {
    path: 'tabs',
    loadChildren: () => import('./tabs/tabs.module').then( m => m.TabsPageModule)
  },
  {
    path: 'walktrough',
    loadChildren: () => import('./walktrough/walktrough.module').then( m => m.WalktroughPageModule)
  },

 
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
